import React from 'react';
import './Modules.scss';
import cardImg from '../../assets/image/homepageback.png';
import '../CategoriesPage/Category.scss';
import {Link } from "react-router-dom"
const Modules = () => {
    const categories = [
        {
            title:' Huquiqiy bilimni oshirish',
            img:cardImg
        },
        {
            title:' Huquiqiy bilimni oshirish',
            img:cardImg
        },
        {
            title:' Huquiqiy bilimni oshirish, Huquiqiy bilimni oshirish',
            img:cardImg
        }
    ];
    return (
        <div className="modules">
            <div className="subcategory container-sm "><span className="disabled">Ketegories</span> <i className="material-icons disabled">keyboard_arrow_right</i> <span className="disabled">Kurslar</span>  <i className="material-icons active">keyboard_arrow_right</i><span className="active">Modullar</span></div>
            <div className="categories-sec container">
                <div className="bg-text">Modullar</div>
                <h3>Modullar</h3>
                <div className="categories ">
                {
                    categories.map(category=>{
                        return <Link to='/categories/courses/modules/testenterence' className="card" >
                            <div className="img-box">
                            <img src={category.img} className="card-img-top" /> </div>
                            <div className="card-body d-flex flex-column justify-contnet-center align-items-center">
                                <div className="card-title">{category.title}</div>
                            </div>
                       
                    </Link>
                    })
                }
                </div>
            </div>
        </div>
    );
}

export default Modules;
